import React from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import Checkbox from '../../../../elements/Checkbox/Checkbox';
import Stylesheet from './Thead.module.css';
import Classnames from 'classnames';
import { TableContext } from '../../context/table';
import { QueryContext } from '../../context/query';
import {ico_font, ico_key, ico_link, 
    ico_calendar_alt, ico_infinity, ico_file_alt, 
    ico_map_marker_alt, ico_user_tie, ico_clock} from '../../../../icon';

const Column = (props) => {
    let location = useLocation();
    let history = useHistory();
    const toggleColumn = selectedColumns => {
        let url = "";
        // clear search
        const search = location.search;
        const searches = search.split('&');
        for (const query of searches) 
            if (!(query.search('column=') > -1)) 
                url += query;
        let selected = selectedColumns;
        const index = selected.findIndex((name) => 
        name === props.value.name);
        if (index !== -1) selected.splice(index, 1);
        else selected.push(`${props.value.name}`);

        if (url !== "" && url.search('select=') === -1)
            history.push(`?column=${selected.join(',')}&${url}`);
        else 
            history.push(`?column=${selected.join(',')}`);
    }
    const isSelected = selected => {
        if (selected.findIndex((name) => name === props.value.name) > -1)
            return true;
        return false;
    }
    const getIcon = _ => {
        switch (props.value.type) {
            case "primaryKey":
                return ico_key;
            case "string":
                return ico_font;
            case "table refference":
                return ico_link;
            case "date":
                return ico_calendar_alt;
            case "number":
                return ico_infinity;
            case "file":
                return ico_file_alt;
            case "branch":
                return ico_map_marker_alt;
            case "user":
                return ico_user_tie;
            case "timestamp":
                return ico_clock;
            default:
                break;
        }
    }
    return (
        <QueryContext.Consumer>
            {query => (
                <div className={Classnames(Stylesheet.Cell, {
                [Stylesheet['Selected']]: isSelected(query.selected.columns)})}
                onClick={_ => toggleColumn(query.selected.columns)}>
                <h4>{getIcon()}</h4>
                <h4>{props.value.title}</h4></div>
            )}
        </QueryContext.Consumer>
        
    )
}

const Thead = (props) => {
    let table = null;
    let query = null;
    const history = useHistory();
    const init = (tableContext, queryContext) => {
        table = tableContext;
        query = queryContext;
    }
    const getRecordSet = _ => {
        // search records take priority before all records sets
        if (query.search.records.length > 0) return query.search.records;
        // report records take priority before all records
        else if (query.report.records.length > 0) return query.report.records;
        // use all records
        else return table.records;
    }
    const onSelectAll = (checked) => {
        // search always has 1 element
        const search = query.search.search[0];
        let list = "";
        if (checked) {
            for (const record of getRecordSet())
                list += list === "" ? record.id : ','+record.id;
            history.push(`?select=${list}${search ? '&search='+search : ""}`)
        }
        else history.push(`?select=${search ? '&search='+search : ""}`)
    }
    const content = config => {
        return (
            <React.Fragment>
                <div className={Stylesheet.Select}>
                    <Checkbox 
                    value={query.selected.records.length === getRecordSet().length
                    && getRecordSet().length > 0}
                    disabled={getRecordSet().length === 0} 
                    onChange={onSelectAll}/>
                </div>
                {!config.disableID
                ? <Column value={{
                    title: "id", 
                    name: "id", 
                    type: "primaryKey"
                }} /> : null}
                {table?.schema?.map((value, index) => (
                    <Column value={value} key={index} />
                ))}
                <Column value={{
                    title: "branch", 
                    name: "branch", 
                    type: "branch"
                }} />
                {!config.disableAuthor
                ? <Column value={{
                    title: "author", 
                    name: "author", 
                    type: "user", 
                    default: "currentuserid"
                }} /> : null}
                {!config.disableTimestamp
                ? <Column value={{
                    title: "date created", 
                    name: "timestamp", 
                    type: "timestamp"
                }} /> : null}
                <div className={Stylesheet.Toolbox}></div>
            </React.Fragment>
        )
    }
    return (
        <TableContext.Consumer>
            {table => (
                <QueryContext.Consumer>
                    {query => (
                        <div className={Stylesheet.Container}>
                            {init(table, query)}
                            {content(table.config)}
                        </div>
                    )}
                </QueryContext.Consumer>
            )}
        </TableContext.Consumer>
    )
}

export default Thead;